import React, { useState, useRef, useCallback, useContext } from 'react';
import columns from './columns';
import { Table, Icon } from 'components';
import { getPatients } from 'services/patients';
import { useAuth } from 'contexts/AuthContext';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import { updateInstitution, getInstitutions } from 'services/institutions';
import { ListContext } from 'contexts/ListContext';
import { showError } from 'utils/alerts';
import { t } from 'i18next';

export const InstitutionsTable = () => {
	const { user } = useAuth();
	const [data, setData] = useState<Array<any>>([]);
	const [loading, setLoading] = useState(false);
	const [pageCount, setPageCount] = useState(0);
	const [totalPatients, setTotalPatients] = useState(0);
	const fetchIdRef = useRef(0);
	const {
		list,
		listData,
		setListData,
		setFilterText,
		fetching,
		fetchList,
		setOrderBy,
	} = useContext<any>(ListContext);

	const fetchData = useCallback(
		async ({ pageSize, pageIndex, filterText, orderBy }) => {
			try {
				let lastPage = localStorage.getItem('lastPagePatients');
				if (lastPage) {
					console.log('last page', lastPage);
					setListData({ ...listData, currentPage: lastPage, size: pageSize });
				} else {
					setListData({
						...listData,
						currentPage: pageIndex,
						size: pageSize,
					});
				}
				setFilterText(filterText);
				setLoading(true);
				const fetchId = ++fetchIdRef.current;
				if (fetchId === fetchIdRef.current) {
					const res = await fetchList();
				}
			} catch (error) {
				Swal.fire({
					title: 'Error',
					text: 'Hubo un problema intentando obtener los usuarios, vuelva a intentar',
				});
				console.log({ error });
			} finally {
				setLoading(false);
			}
		},
		[]
	);

	const removeInstitution = async (selected: any) => {
		Swal.fire({
			title: t('areYouSure'),
			text: selected?.isActive
				? t('doYouWantToInactivate', {
						element: t('institution'),
						name: selected?.name,
				  })
				: t('doYouWantToActivate', {
						element: t('institution'),
						name: selected?.name,
				  }),
			icon: 'warning',
			confirmButtonText: t('yes'),
			showCancelButton: true,
			customClass: {
				cancelButton: '!bg-transparent !text-orange',
			},
		}).then(async (result) => {
			if (result.isConfirmed) {
				try {
					const { data: result } = await updateInstitution(selected.id, {
						isActive: !selected?.isActive,
					});
					toast.success(t('institutionModifiedSuccess'));
					setListData({ ...listData });
				} catch (error) {
					console.log({ error });
					showError(`Error on trying to inactive user ${selected?.name}.`);
				}
			}
		});
	};

	return (
		<Table
			cols={columns}
			fetchData={fetchData}
			loading={loading || fetching}
			pageCount={listData?.totalPages}
			noDataMsg={t('noInstitutionsToShow')}
			totalItems={listData?.totalItems}
			removeFunction={removeInstitution}
			data={list}
		/>
	);
};
